import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Grid2, TextField, Typography } from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import classnames from "classnames";
import AdvertisementExistingTypes from "components/common/AdvertisementTypes";
import DatePickerRange from "components/common/DatePickerRange";
import ReviewStatusTypesSelect from "components/global/ReviewStatusTypesSelect";
import TagSelect from "components/global/TagSelect";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import MultiOptionsSwitch from "../common/form/MultioptionSwitch";
import { actions } from "./logic/formActions";
import { styles } from "./styles";
import "./styles.css";

const REVIEWEDVALUES = {
    all: null,
    reviewed: true,
    no_reviewed: false,
};
const REPORTEDVALUES = {
    all: null,
    reported: true,
    no_reported: false,
};
const FINALVALUES = {
    all: null,
    final: true,
    no_final: false,
};
const EXCEPTIONVALUES = {
    all: null,
    exception: true,
    no_exception: false,
};
function getCutTypeOptions() {
    return [
        {
            value: REVIEWEDVALUES.all,
            label: "All",
        },
        {
            value: REVIEWEDVALUES.reviewed,
            label: "Reviewed",
        },
        {
            value: REVIEWEDVALUES.no_reviewed,
            label: "Not Reviewed",
        },
    ];
}
export const getReportedOptions = () => [
    {
        value: REPORTEDVALUES.all,
        label: "All",
    },
    {
        value: REPORTEDVALUES.reported,
        label: "Reported",
    },
    {
        value: REPORTEDVALUES.no_reported,
        label: "Not Reported",
    },
];
export const getFinalOptions = () => [
    {
        value: FINALVALUES.all,
        label: "All",
    },
    {
        value: FINALVALUES.final,
        label: "Final",
    },
    {
        value: FINALVALUES.no_final,
        label: "Rough",
    },
];
export const getExceptionOptions = () => [
    {
        value: EXCEPTIONVALUES.all,
        label: "All",
    },
    {
        value: EXCEPTIONVALUES.exception,
        label: "Exception",
    },
    {
        value: EXCEPTIONVALUES.no_exception,
        label: "No Exception",
    },
];

const AdvertisementInformationForm = ({
    defaultExpanded = true,
    onFilmForm = false,
    ...props
}) => {

    const [advNameState, setAdvNameState] = useState("");
    const [advInstructions, setAdvInstructions] = useState("");
    const [assocPrivNotes, setAssocPrivNotes] = useState("");
    const [existingTypes, setExistingTypes] = useState([]);

    useEffect(() => {
        if (advNameState) setAdvNameState("");
        if (advInstructions) setAdvInstructions("");
        if (assocPrivNotes) setAssocPrivNotes("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.searchFormCleared]);

    const expandPanelStyle = useStyles();

    const {
        classes,
        onChange,

        advStatus,
        advEnteredDateStart,
        advEnteredDateEnd,
        advReviewed,
        advReported,
        advFinal,
        advException,
        tags,
    } = props;

    const handleInputChange = (e) => {
        e.persist();
        if (e.keyCode !== 13) {
            switch (e.target.name) {
            case "advName":
                setAdvNameState(e.target.value);
                break;
            case "advInstructions":
                setAdvInstructions(e.target.value);
                break;
            case "assocPrivNotes":
                setAssocPrivNotes(e.target.value);
                break;
            default:
                break;
            }
        }
    };

    const handleInputKeyUp = (e) => {
        if (e.keyCode === 13 || e.target.value === "") {
            onChange(e);
            if (e.target.value === "") {
                switch (e.target.name) {
                case "advName":
                    setAdvNameState(e.target.value);
                    break;
                case "advInstructions":
                    setAdvInstructions(e.target.value);
                    break;
                case "assocPrivNotes":
                    setAssocPrivNotes(e.target.value);
                    break;
                default:
                    break;
                }
            }
        }
    };

    function onChangeTags(value) {
        onChange({
            target: {
                name: "tags",
                value,
            },
        });
    }

    const onExistingTypesChange = (value) => {
        onChange({
            target: {
                name: "advertisementExistingTypes",
                value,
            },
        });
        setExistingTypes(value);
    };

    const reviewedOptions = getCutTypeOptions();
    const reportedOptions = getReportedOptions();
    const finalOptions = getFinalOptions();
    const exceptionOptions = getExceptionOptions();

    return (
        (<Grid2 container style={props.formStyles}>
            <Accordion className={expandPanelStyle.root} defaultExpanded={defaultExpanded}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={expandPanelStyle.summary}>
                    <Typography>Advertisement Information</Typography>
                </AccordionSummary>
                <AccordionDetails className={expandPanelStyle.details}>
                    <Grid2 container paddingRight={3} spacing={2}>
                        {onFilmForm && (
                            <Grid2
                                className={classnames(expandPanelStyle.item, expandPanelStyle.selectWrapper)}
                                size={12}
                            >
                                <AdvertisementExistingTypes
                                    placeholder="Existing Advertising Types"
                                    onChange={onExistingTypesChange}
                                    value={existingTypes}
                                />
                            </Grid2>
                        )}
                        <Grid2 size={12} padding={1}>
                            <TextField
                                className={classes.formControl}
                                label="All Advertising Names"
                                margin="normal"
                                variant="outlined"
                                name="advName"
                                value={advNameState}
                                onChange={handleInputChange}
                                onKeyUp={handleInputKeyUp}
                                onBlur={(e) => e.target.value && onChange({ target: { value: e.target.value, name: "advName" } }) }
                            />
                        </Grid2>
                        <Grid2
                            className={classnames(expandPanelStyle.item, expandPanelStyle.selectWrapper)}
                            size={12}
                        >
                            <ReviewStatusTypesSelect
                                placeholder="All Status"
                                multiple={false}
                                name="advStatus"
                                defaultValue={props.searchFormCleared ? null : advStatus}
                                onChange={(e) => onChange({ target: { value: e, name: "advStatus" } })}
                            />
                            {}
                        </Grid2>
                        <Grid2 size={12} padding={1}>
                            <TextField
                                className={classes.formControl}
                                label="All Instructions"
                                margin="normal"
                                variant="outlined"
                                name="advInstructions"
                                value={advInstructions}
                                onChange={handleInputChange}
                                onKeyUp={handleInputKeyUp}
                                onBlur={(e) => e.target.value && onChange({ target: { value: e.target.value, name: "advInstructions" } }) }
                            />
                        </Grid2>
                        <Grid2 size={12} padding={1}>
                            <TextField
                                id="outlined-basic"
                                className={classes.formControl}
                                label="All Private Notes"
                                margin="normal"
                                variant="outlined"
                                name="assocPrivNotes"
                                value={assocPrivNotes}
                                onChange={handleInputChange}
                                onKeyUp={handleInputKeyUp}
                                onBlur={(e) => e.target.value && onChange({ target: { value: e.target.value, name: "assocPrivNotes" } }) }
                            />
                        </Grid2>
                        {!onFilmForm && (
                            <Grid2
                                container
                                className={classnames(expandPanelStyle.item, expandPanelStyle.selectWrapper)}
                                size={12}
                            >
                                <TagSelect defaultValue={props.searchFormCleared ? [] : tags} onChange={onChangeTags} />
                            </Grid2>
                        )}

                        <Grid2 container style={{ paddingRight: 0 }} size={12}>
                            <DatePickerRange
                                dateName="Entered"
                                fieldName="advEnteredDate"
                                start={advEnteredDateStart}
                                end={advEnteredDateEnd}
                                onChange={(field) =>
                                    onChange({
                                        target: {
                                            name: Object.entries(field)[0][0],
                                            value: Object.entries(field)[0][1],
                                        },
                                    })
                                }
                                startSuffix="Start"
                                endSuffix="End"
                            />
                        </Grid2>
                        {!onFilmForm && (
                            <React.Fragment>
                                <Grid2 className={expandPanelStyle.selectWrapper} size={12}>
                                    <MultiOptionsSwitch
                                        value={advReviewed}
                                        options={reviewedOptions}
                                        onChange={(e) => onChange({ target: { value: e, name: "advReviewed" } })}
                                        context={"reviewed"}
                                    />
                                </Grid2>
                                <Grid2 className={expandPanelStyle.selectWrapper} size={12}>
                                    <MultiOptionsSwitch
                                        value={advReported}
                                        options={reportedOptions}
                                        onChange={(e) => onChange({ target: { value: e, name: "advReported" } })}
                                        context={"reported"}
                                    />
                                </Grid2>
                                <Grid2 className={expandPanelStyle.selectWrapper} size={12}>
                                    <MultiOptionsSwitch
                                        value={advFinal}
                                        options={finalOptions}
                                        onChange={(e) => onChange({ target: { value: e, name: "advFinal" } })}
                                        context={"final"}
                                    />
                                </Grid2>
                                <Grid2 className={expandPanelStyle.selectWrapper} size={12}>
                                    <MultiOptionsSwitch
                                        value={advException}
                                        options={exceptionOptions}
                                        onChange={(e) => onChange({ target: { value: e, name: "advException" } })}
                                        context={"exception"}
                                    />
                                </Grid2>
                            </React.Fragment>
                        )}
                    </Grid2>
                </AccordionDetails>
            </Accordion>
        </Grid2>)
    );
};

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    summary: {
        minHeight: "45px",
        height: "45px",
    },
    item: {
        display: "flex",
    },
    details: {
        flexDirection: "column",
        paddingLeft: "10px !important",
        paddingRight: "10px !important",
    },
    date: {
        display: "flex",
        paddingLeft: 5,
        paddingRight: 5,
        marginTop: 5,
        marginBottom: 10,
    },
    selectWrapper: {
        padding: "8px 0 8px 8px !important",
    },
    labelByHand: {
        paddingLeft: 10,
        paddingBottom: 5,
        color: "#808080",
        width: "100%",
    },
});



AdvertisementInformationForm.propTypes = {
    onChange: PropTypes.func.isRequired,
};

const mapStateToProps = ({
    advertising: {
        form: {
            advName,
            advStatus,
            advEnteredDateStart,
            advEnteredDateEnd,
            advReviewed,
            advReported,
            advFinal,
            advException,
        },
        advertisementTypes,

        searchFormCleared,
    },
}) => ({
    advName,
    advStatus,
    advEnteredDateStart,
    advEnteredDateEnd,
    advReviewed,
    advReported,
    advFinal,
    advException,
    advertisementTypes,

    searchFormCleared,
});

const mapDispatchToProps = (dispatch) => ({
    getAdvertisementTypes: (url) => dispatch(actions.GET_ADVERTISEMENT_TYPE.send(url)),
    getReviewStatusTypes: (url) => dispatch(actions.GET_REVIEW_STATUS_TYPE.send(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AdvertisementInformationForm));
